import {
  getPostApiV1ThreeLetterCodePartnerAdminsUsersMutationFetcher,
  getPostApiV1ThreeLetterCodePartnerAdminsUsersMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import { useMutation } from '@fukuri-admins/hooks/common';
import type { AxiosError } from 'axios';

/**
 * 利用者追加APIを実行するカスタムフック
 *
 * @param threeLetterCode - パートナーコード
 * @param options - コールバックオプション
 * @param options.onSuccess - 成功時のコールバック
 * @param options.onError - エラー時のコールバック
 */
export const usePostPartnerAdminsUsers = (
  threeLetterCode: string,
  options?: {
    onSuccess?: () => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) => {
  return useMutation(
    getPostApiV1ThreeLetterCodePartnerAdminsUsersMutationKey(threeLetterCode),
    getPostApiV1ThreeLetterCodePartnerAdminsUsersMutationFetcher(threeLetterCode),
    options
  );
};
